// import React from 'react';

// import featureIcon1 from '../../assets/img/feature/fea-icon-1.png';
// import featureIcon2 from '../../assets/img/feature/fea-icon-2.png';
// import featureIcon3 from '../../assets/img/feature/fea-icon-3.png';
// import featureIcon4 from '../../assets/img/feature/fea-icon-4.png';
// import featureIcon5 from '../../assets/img/feature/fea-icon-5.png';

// const Feature = () => {
//   return (
//     <div className="feature-2__area feature-2__mlr z-index-5 pb-60">
//       <div className="container-fluid">
//         <div className="row row-cols-5 row-cols-xxl-5 row-cols-xl-5">
//           <div
//             className=" col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".3s"
//           >
//             <div className="feature-2__item text-center">
//               <div className="feature-2__item-overly"></div>
//               <div className="feature-2__icon feature-2__icon-color-1 z-index">
//                 <span>
//                   <img src={featureIcon1} alt="" />
//                 </span>
//               </div>
//               <div className="feature-2__text z-index">
//                 <h4 className="feature-2__title-sm">Development</h4>
//               </div>
//             </div>
//           </div>
//           <div
//             className=" col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".5s"
//           >
//             <div className="feature-2__item text-center">
//               <div className="feature-2__item-overly"></div>
//               <div className="feature-2__icon feature-2__icon-color-2 z-index">
//                 <span>
//                   <img src={featureIcon2} alt="" />
//                 </span>
//               </div>
//               <div className="feature-2__text z-index">
//                 <h4 className="feature-2__title-sm">Marketing</h4>
//               </div>
//             </div>
//           </div>
//           <div
//             className=" col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".7s"
//           >
//             <div className="feature-2__item text-center">
//               <div className="feature-2__item-overly"></div>
//               <div className="feature-2__icon feature-2__icon-color-3 z-index">
//                 <span>
//                   <img src={featureIcon3} alt="" />
//                 </span>
//               </div>
//               <div className="feature-2__text z-index">
//                 <h4 className="feature-2__title-sm">Promoting</h4>
//               </div>
//             </div>
//           </div>
//           <div
//             className=" col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".8s"
//           >
//             <div className="feature-2__item text-center">
//               <div className="feature-2__item-overly"></div>
//               <div className="feature-2__icon feature-2__icon-color-4 z-index">
//                 <span>
//                   <img src={featureIcon4} alt="" />
//                 </span>
//               </div>
//               <div className="feature-2__text z-index">
//                 <h4 className="feature-2__title-sm">Optimization</h4>
//               </div>
//             </div>
//           </div>
//           <div
//             className=" col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
//             data-wow-duration=".9s"
//             data-wow-delay=".9s"
//           >
//             <div className="feature-2__item text-center">
//               <div className="feature-2__item-overly"></div>
//               <div className="feature-2__icon feature-2__icon-color-5 z-index">
//                 <span>
//                   <img src={featureIcon5} alt="" />
//                 </span>
//               </div>
//               <div className="feature-2__text z-index">
//                 <h4 className="feature-2__title-sm">Discovery</h4>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Feature;
import React from 'react';

import featureIcon1 from '../../assets/img/feature/fea-icon-1.png';
import featureIcon2 from '../../assets/img/feature/fea-icon-2.png';
import featureIcon3 from '../../assets/img/feature/fea-icon-3.png';
import featureIcon4 from '../../assets/img/feature/fea-icon-4.png';
import featureIcon5 from '../../assets/img/feature/fea-icon-5.png';

const Feature = () => {
  return (
    <div className="feature-2__area feature-2__mlr z-index-5 pb-60">
      <div className="container-fluid">
        <div className="row row-cols-5 row-cols-xxl-5 row-cols-xl-5">
          {/* Card 1: ERP & CRM Solutions */}
          <div
            className="col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="feature-2__item text-center">
              <div className="feature-2__item-overly"></div>
              <div className="feature-2__icon feature-2__icon-color-1 z-index">
                <span>
                  <img src={featureIcon1} alt="ERP & CRM Solutions" />
                </span>
              </div>
              <div className="feature-2__text z-index">
                <h4 className="feature-2__title-sm">ERP &amp; CRM Solutions</h4>
              </div>
            </div>
          </div>
          {/* Card 2: Inventory & Barcoding */}
          <div
            className="col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="feature-2__item text-center">
              <div className="feature-2__item-overly"></div>
              <div className="feature-2__icon feature-2__icon-color-2 z-index">
                <span>
                  <img src={featureIcon2} alt="Inventory & Barcoding" />
                </span>
              </div>
              <div className="feature-2__text z-index">
                <h4 className="feature-2__title-sm">Inventory &amp; Barcoding</h4>
              </div>
            </div>
          </div>
          {/* Card 3: Production & Assets */}
          <div
            className="col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="feature-2__item text-center">
              <div className="feature-2__item-overly"></div>
              <div className="feature-2__icon feature-2__icon-color-3 z-index">
                <span>
                  <img src={featureIcon3} alt="Production & Assets" />
                </span>
              </div>
              <div className="feature-2__text z-index">
                <h4 className="feature-2__title-sm">Production &amp; Assets</h4>
              </div>
            </div>
          </div>
          {/* Card 4: Mobile Applications */}
          <div
            className="col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <div className="feature-2__item text-center">
              <div className="feature-2__item-overly"></div>
              <div className="feature-2__icon feature-2__icon-color-4 z-index">
                <span>
                  <img src={featureIcon4} alt="Mobile Applications" />
                </span>
              </div>
              <div className="feature-2__text z-index">
                <h4 className="feature-2__title-sm">Mobile Applications</h4>
              </div>
            </div>
          </div>
          {/* Card 5: Custom Software Development */}
          <div
            className="col-xxl col-lg-4 col-sm-6 col-md-4 col-12 mb-40 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <div className="feature-2__item text-center">
              <div className="feature-2__item-overly"></div>
              <div className="feature-2__icon feature-2__icon-color-5 z-index">
                <span>
                  <img src={featureIcon5} alt="Custom Software Development" />
                </span>
              </div>
              <div className="feature-2__text z-index">
                <h4 className="feature-2__title-sm">Custom Software Development</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
